import { render, staticRenderFns } from "./Section7.vue?vue&type=template&id=64600a81&scoped=true&"
import script from "./Section7.vue?vue&type=script&lang=js&"
export * from "./Section7.vue?vue&type=script&lang=js&"
import style0 from "./Section7.vue?vue&type=style&index=0&id=64600a81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64600a81",
  null
  
)

export default component.exports